import { Fragment } from 'react';

import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SmallGridRowIcons = ({ topHeaderInfo, onDeleteClicked }) => (
  <Fragment>
    <button
      className={global.IconButton}
      type="button"
      onClick={() => onDeleteClicked(topHeaderInfo)}>
      <DeleteIcon />
    </button>
  </Fragment>
);

//TODO table not displaying correctly
const SmallGridRow = ({ topHeaderInfo, onDeleteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}>
      <span></span>&nbsp;
      <SmallGridRowIcons
        topHeaderInfo={topHeaderInfo}
        onDeleteClicked={onDeleteClicked} />
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Display Order
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {topHeaderInfo?.displayOrder || 0}
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Record List
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {topHeaderInfo?.recordListName || ''}
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Name to Show
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {topHeaderInfo?.nameToShow || ''}
        </div>
      </div>
    </div>
  </div>
);

const LaneSheetMeetTopHeaderNotesSmallGrid = ({ isLoading, gridData, onDeleteClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}><div className={global.SmallTableRowLabels}>Loading...</div></div>
        </div>
      ) : Array.isArray(gridData) && gridData.length > 0
        ? gridData.map((topHeaderInfo, i) =>
          <SmallGridRow
            key={i}
            topHeaderInfo={topHeaderInfo}
            onDeleteClicked={onDeleteClicked} />
        ) : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}><div className={global.SmallTableRowLabels}>No Results</div></div>
          </div>
        )
    }
  </div>
);

export default LaneSheetMeetTopHeaderNotesSmallGrid;